import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RetryEffects } from './effects';
import { coreReducer, FEATURE_NAME_CORE } from './reducer/core.reducer';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    StoreModule.forFeature(FEATURE_NAME_CORE, coreReducer),
    EffectsModule.forFeature([RetryEffects]),
  ],
  declarations: [],
})
export class CoreModule {}
